import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface HeaderRowProps {
  bgColor?: 'default' | 'transparent' | 'white';
  sticky?: boolean;
}

const HeaderRow = styled.tr<HeaderRowProps>`
  position: relative;
  width: 100%;
  height: ${toRem(35)};
  background-color: ${theme.color.neutral[100]};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  vertical-align: middle;

  ${({ bgColor }) =>
    bgColor === 'transparent' &&
    css`
      background-color: transparent;
    `}

  ${({ bgColor }) =>
    bgColor === 'white' &&
    css`
      background-color: ${theme.color.white};
    `}

  ${({ bgColor, sticky }) =>
    sticky &&
    bgColor === undefined &&
    css`
      th {
        &:first-child {
          background-color: ${theme.color.neutral[100]};
        }
      }
    `}

    ${({ bgColor, sticky }) =>
    sticky &&
    bgColor === 'white' &&
    css`
      th {
        &:first-child {
          background-color: ${theme.color.white};
        }
      }
    `}
`;

export default HeaderRow;
